// Types
import type { Action } from "./types";

/**
 * @desc load a company into the shape the company dashboard selector expects, so
 * the shared class editor resolves the company being viewed rather than the
 * signed-in user's own
 * @param {*} data business guid
 * @return {*}  {Action}
 */
export const fetchCompanyForClasses = (data: any): Action => ({
  type: "FETCH_COMPANY_FOR_CLASSES",
  data,
});
